import React from 'react';
import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import TagColorPicker from '../components/TagColorPicker';
import { TagEditContentProps } from '../tagComponentPropTypes';

const TagColorPopup: React.FC<Omit<TagEditContentProps, 'taggedElements' | 'boardVirtualPathToRootMap'>> = ({
    tag,
    showColorMenu,
    closePopups,
    updateTag,
}) => {
    if (!tag) return null;

    return (
        <div className="TagColorPopup">
            <FloatingPanel
                className="light !w-auto"
                selector={`#tag-color-${tag.id}`}
                pollPosition
                offset={20}
                showArrow={false}
                distance={0}
                alignment={TooltipAlignment.START}
                position={TooltipPositions.RIGHT}
                show={showColorMenu}
            >
                <PopupPanelMouseManager visible={showColorMenu} popupId={PopupIds.TAG_EDIT_COLOR} closePopup={() => {}}>
                    <div className="mb-3 mt-3">
                        <TagColorPicker tag={tag} closePopup={closePopups} updateTag={updateTag} />
                    </div>
                </PopupPanelMouseManager>
            </FloatingPanel>
        </div>
    );
};

export default TagColorPopup;
